// theme-sources/js/core/logger.js

import { CONFIG } from "./config";

const enabled = CONFIG.DEBUG;

export const logger = {
  info(scope, message, payload) {
    if (!enabled) return;
    console.info(`[${scope}] ${message}`, payload ?? "");
  },

  debug(scope, message, payload) {
    if (!enabled) return;
    console.debug(`[${scope}] ${message}`, payload ?? "");
  },

  warn(scope, message, payload) {
    if (!enabled) return;
    console.warn(`[${scope}] ${message}`, payload ?? "");
  },

  error(scope, message, payload) {
    if (!enabled) return;
    console.error(`[${scope}] ${message}`, payload ?? "");
  },
};
